import { Reveal } from "@/components/site/Reveal";

export const About = () => (
  <section id="about" className="about" data-testid="about-section">
    <div className="about-inner shell">
      <Reveal as="h2" className="about-title">
        ABOUT
        <br />
        US
      </Reveal>
      <span className="about-divider" aria-hidden="true" />
      <Reveal as="p" delay={0.12} className="about-text" data-testid="about-text">
        <strong>The Blake Smith Company LLC</strong> is a creative and technology-focused business
        established in 2023. We combine marketing, digital strategy, web development, and app creation
        to deliver real solutions that help businesses grow, operate smarter, and reach more customers.
      </Reveal>
    </div>
  </section>
);
